"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var design_language_1 = require("@doordash/design-language");
var React = __importStar(require("react"));
var Icons_1 = require("../Icons");
var FooterConstants_1 = require("./FooterConstants");
var FooterStyles_1 = require("./FooterStyles");
var IOS_DASHER_APP_URL = 'https://itunes.apple.com/us/app/doordash-dasher/id1451754591';
var ANDROID_DASHER_APP_URL = 'https://play.google.com/store/apps/details?id=com.doordash.driverapp';
var APPLE_STORE_URL = 'https://itunes.apple.com/us/app/doordash-food-delivery/id719972451?mt=8';
var GOOGLE_STORE_URL = 'https://play.google.com/store/apps/details?id=com.dd.doordash';
var FACEBOOK_SOC_URL = 'http://facebook.com/doordash';
var TWITTER_SOC_URL = 'http://twitter.com/doordash';
var INSTAGRAM_SOC_URL = 'http://instagram.com/doordash';
var Footer = function (_a) {
    var _b = _a.withDarkFooter, withDarkFooter = _b === void 0 ? true : _b, isDasherApp = _a.isDasherApp, _c = _a.hideMobileIcons, hideMobileIcons = _c === void 0 ? false : _c, _d = _a.showDoNotSellLink, showDoNotSellLink = _d === void 0 ? false : _d, renderChangeLanguage = _a.renderChangeLanguage, strings = _a.strings;
    var baseTextColor = withDarkFooter ? design_language_1.Colors.SystemGrey30 : undefined;
    var menuTitleColor = withDarkFooter ? design_language_1.Colors.SystemWhite : undefined;
    var menuList = hideMobileIcons ? FooterConstants_1.linkMenuHideMobileIcons(strings) : FooterConstants_1.linkMenu(strings);
    return (React.createElement(FooterStyles_1.FooterRoot, { withDarkFooter: withDarkFooter },
        React.createElement(FooterStyles_1.FooterContent, null,
            React.createElement(FooterStyles_1.LinkPanel, null,
                React.createElement(FooterStyles_1.LinkMenu, null, menuList.map(function (menu) { return (React.createElement(FooterStyles_1.MenuColumn, null, menu.map(function (data) { return (React.createElement(React.Fragment, null,
                    React.createElement(FooterStyles_1.MenuTitle, { color: menuTitleColor }, data.title),
                    data.links.map(function (link) { return (React.createElement(FooterStyles_1.HoverLink, { key: link.name, href: link.url },
                        React.createElement(design_language_1.Text, { styles: design_language_1.Text.Styles.SectionSubtext, color: baseTextColor }, link.name))); }))); }))); })),
                React.createElement(FooterStyles_1.OpenHours, null,
                    React.createElement(design_language_1.StackChildren, null,
                        React.createElement(design_language_1.InlineChildren, { size: design_language_1.InlineChildren.Sizes.XLarge },
                            React.createElement(FooterStyles_1.HoverLink, { href: FACEBOOK_SOC_URL, target: "_blank", rel: "noopener" },
                                React.createElement(FooterStyles_1.SocialIcon, { size: design_language_1.Icon.Sizes.XLarge, type: design_language_1.Icon.Types.LogoFacebook, accessibilityLabel: "Facebook" })),
                            React.createElement(FooterStyles_1.HoverLink, { href: TWITTER_SOC_URL, target: "_blank", rel: "noopener" },
                                React.createElement(FooterStyles_1.SocialIcon, { size: design_language_1.Icon.Sizes.XLarge, type: design_language_1.Icon.Types.LogoTwitter, accessibilityLabel: "Twitter" })),
                            React.createElement(FooterStyles_1.HoverLink, { href: INSTAGRAM_SOC_URL, target: "_blank", rel: "noopener" },
                                React.createElement(FooterStyles_1.SocialIcon, { size: design_language_1.Icon.Sizes.XLarge, type: design_language_1.Icon.Types.LogoInstagram, accessibilityLabel: "Instagram" }))),
                        !hideMobileIcons && (React.createElement(FooterStyles_1.AppStoreWrapper, null,
                            React.createElement(FooterStyles_1.HoverButton, { href: isDasherApp ? ANDROID_DASHER_APP_URL : GOOGLE_STORE_URL },
                                React.createElement(FooterStyles_1.MobileButton, null,
                                    React.createElement(Icons_1.AndroidBadgeIcon, { size: Icons_1.IconSizes.X_LARGE, color: design_language_1.Colors.SystemWhite }))),
                            React.createElement(FooterStyles_1.HoverButton, { href: isDasherApp ? IOS_DASHER_APP_URL : APPLE_STORE_URL },
                                React.createElement(FooterStyles_1.MobileButton, null,
                                    React.createElement(Icons_1.AppleBadgeIcon, { size: Icons_1.IconSizes.X_LARGE, color: design_language_1.Colors.SystemWhite }))))),
                        React.createElement(design_language_1.InlineChildren, null,
                            React.createElement(design_language_1.Text, { color: baseTextColor },
                                React.createElement(FooterStyles_1.HoverLink, { href: '/terms/', target: "_blank", rel: "noopener" }, strings.termsOfService),
                                ' & ',
                                React.createElement(FooterStyles_1.HoverLink, { href: '/privacy/', target: "_blank", rel: "noopener" }, strings.privacy))),
                        showDoNotSellLink && (React.createElement(FooterStyles_1.HoverLink, { href: "/consent/california?redirect_to=" + new URL(window.location.href) },
                            React.createElement(design_language_1.Text, { styles: design_language_1.Text.Styles.Regular12, color: baseTextColor }, strings.ccpaDoNotSell))),
                        React.createElement(design_language_1.Text, { color: menuTitleColor },
                            "\u00A9 ",
                            new Date().getFullYear(),
                            " DoorDash, All rights reserved"),
                        React.createElement("div", null, renderChangeLanguage && renderChangeLanguage())))))));
};
Footer.defaultProps = {
    strings: {
        getToKnowUs: 'Get To Know Us',
        aboutUs: 'About Us',
        careers: 'Careers',
        blog: 'Blog',
        stories: 'DoorDash Stories',
        linkedIn: 'LinkedIn',
        glassdoor: 'Glassdoor',
        accessibility: 'Accessibility',
        letUsHelpYou: 'Let Us Help You',
        accountDetails: 'Account Details',
        orderHistory: 'Order History',
        help: 'Help',
        doingBusiness: 'Doing Business',
        becomeADasher: 'Become A Dasher',
        beAPartnerRestaurant: 'Be A Partner Restaurant',
        getDashersForDeliveries: 'Get Dashers For Deliveries',
        drivingOpportunities: 'Driving Opportunities',
        deliveryHours: 'Delivery Hours',
        everyDayHours: 'Every day: 5:30AM - 4:00AM',
        termsOfService: 'Terms Of Service',
        privacy: 'Privacy',
        deliveryLocations: 'Delivery Locations',
        getTheApp: 'Get the App',
        appStore: 'App Store',
        googlePlay: 'Google Play',
        ccpaDoNotSell: 'Do not sell'
    }
};
exports["default"] = Footer;
